import { createContext } from 'react';

export const VenueDatesContext = createContext<{
  panelOpen: boolean;
  setPanelOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  panelOpen: false,
});
